@if (config(); as config) {
    <div class="border-bottom border-3" [style.--bs-border-color]="'var(--bs-gray-400)'"></div>
    <div class="container">
        <div
            class="d-flex justify-content-center justify-content-sm-between align-items-center flex-wrap my-3 pb-4 border-bottom border-1"
            [style.--bs-border-color]="'var(--bs-gray-200)'">
            @if (config.utilitySettings.logo) {
                <img src="{{ config.utilitySettings.logo }}" alt="Logo" class="mb-3 mb-md-0 company-logo" />
            } @else {
                <h3 class="mb-0">{{ config.utilitySettings.companyName }}</h3>
            }
        </div>
    </div>
}

@if (wizardQuote(); as quote) {
    <div class="page-content">
        <div class="container my-4">
            <div class="row">
                <div class="col-lg-8">
                    <h1>Installer Job Overview</h1>

                    <div class="d-flex flex-row flex-wrap justify-content-between">
                        <div>
                            <p class="mb-1 text-body-secondary">Quotation No.</p>
                            <p class="fw-bold">#{{ quote.quoteId }}</p>
                        </div>
                    </div>

                    @if (quote.quoteDetails || quote.documentText) {
                        <div class="card mt-4">
                            <div class="card-body">
                                <h5 class="text-body-secondary mb-3">Job Details</h5>
                                @if (quote.quoteDetails) {
                                    <p class="pre-line">{{ quote.quoteDetails }}</p>
                                }
                                @if (quote.documentText) {
                                    <p class="pre-line mb-0">{{ quote.documentText }}</p>
                                }
                            </div>
                        </div>
                    }

                    <div class="card mt-4">
                        <div class="card-body">
                            <h5 class="text-body-secondary mb-3">Parts</h5>
                            @for (item of quote.orderItems; track $index) {
                                <div class="pb-2 mb-2 border-bottom">
                                    <p class="fw-bold mb-0">{{ item.quantity }} x {{ item.name }}</p>
                                </div>
                            } @empty {
                                <p class="mb-0 text-body-secondary">No parts on this quote.</p>
                            }
                        </div>
                    </div>

                    <div class="card mt-4">
                        <div class="card-body">
                            <h5 class="text-body-secondary mb-3">Radiators</h5>
                            @if (quote.radiators.length) {
                                <div class="table-responsive">
                                    <table class="table mb-0">
                                        <thead>
                                            <tr>
                                                <th>Room</th>
                                                <th>Manufacturer</th>
                                                <th>Type</th>
                                                <th class="text-end">Length</th>
                                                <th class="text-end">Height</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (radiator of quote.radiators; track $index) {
                                                <tr>
                                                    <td>{{ radiator.room }}</td>
                                                    <td>{{ radiator.manufacturer }}</td>
                                                    <td>{{ radiator.type }}</td>
                                                    <td class="text-end">{{ radiator.length }}</td>
                                                    <td class="text-end">{{ radiator.height }}</td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            } @else {
                                <p class="mb-0 text-body-secondary">No radiators on this quote.</p>
                            }
                        </div>
                    </div>

                    <div class="card mt-4">
                        <div class="card-body">
                            <h5 class="text-body-secondary mb-3">Optional Work</h5>
                            @for (item of quote.optionalWork; track $index) {
                                <div class="d-flex align-items-center pb-2 mb-2 border-bottom">
                                    <p class="mb-0 pre-line">{{ item.description }}</p>
                                    <span class="badge ms-auto" [ngClass]="item.accepted ? 'text-bg-success' : 'text-bg-secondary'">
                                        {{ item.accepted ? 'Accepted' : 'Not accepted' }}
                                    </span>
                                </div>
                            } @empty {
                                <p class="mb-0 text-body-secondary">No optional work on this quote.</p>
                            }
                        </div>
                    </div>

                    <div class="card mt-4">
                        <div class="card-body">
                            <h5 class="text-body-secondary mb-3">Additional Work</h5>
                            @for (item of quote.additionalWork; track $index) {
                                <div class="pb-2 mb-2 border-bottom">
                                    <p class="mb-0 pre-line">{{ item.description }}</p>
                                </div>
                            } @empty {
                                <p class="mb-0 text-body-secondary">No additional work on this quote.</p>
                            }
                        </div>
                    </div>

                    <div class="card mt-4">
                        <div class="card-body">
                            <h5 class="text-body-secondary mb-3">Survey Questions & Answers</h5>
                            @for (qa of quote.questionsAndAnswers; track $index) {
                                <div class="pb-2 mb-2 border-bottom">
                                    <p class="mb-1 small text-body-secondary">{{ qa.question }}</p>
                                    <p class="mb-0 fw-bold pre-line">{{ qa.answer || '-' }}</p>
                                </div>
                            } @empty {
                                <p class="mb-0 text-body-secondary">No questions were answered for this quote.</p>
                            }
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="card bg-body-tertiary mt-3 mt-lg-0">
                        <div class="card-body">
                            <h5 class="card-title">Customer</h5>
                            <p class="fw-bold mb-1">{{ quote.customerInstallerModel.fullName }}</p>
                            @for (line of addressLines(); track $index) {
                                <p class="mb-0">{{ line }}</p>
                            }
                        </div>
                    </div>

                    <div class="card mt-4">
                        <div class="card-body">
                            <h5 class="card-title">Notes</h5>
                            <p class="mb-1 small text-body-secondary">Engineer Note</p>
                            <p class="pre-line">{{ quote.engineerNote || 'None' }}</p>
                            <p class="mb-1 small text-body-secondary">Customer Acceptance Note</p>
                            <p class="pre-line mb-0">{{ quote.acceptanceNote || 'None' }}</p>
                        </div>
                    </div>

                    <div class="card mt-4">
                        <div class="card-body">
                            <h5 class="card-title">Files</h5>
                            @for (file of quote.files; track $index) {
                                <div class="pb-2 mb-2 border-bottom">
                                    @if (file.fullUrl) {
                                        <a [href]="file.fullUrl" target="_blank" rel="noopener">{{
                                            file.originalFileName || 'File'
                                        }}</a>
                                    } @else {
                                        <span>{{ file.originalFileName || 'File' }}</span>
                                    }
                                </div>
                            } @empty {
                                <p class="mb-0 text-body-secondary">No files attached.</p>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
